var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('vue-pdf',{attrs:{"src":_vm.pdfUrl}})],1),_c('button',{on:{"click":_vm.downloadPdf}},[_vm._v("下载 PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }